export default {
    computed: {
        uid() {
            return Math.floor(Date.now() * Math.random()).toString(16);
        },
    },
}